import { Deserializable } from '../../protocols/deserializable';
import { CardType } from '../../../modules/display/components/menus/marketing-menu/building-blocks/menu-cards/card-type.enum';
import type { CardSize } from '../../enum/dto/card-size';

export const DefaultCardCount = '4';
export const DefaultCardStartAt = '1';

export class MenuMetadata implements Deserializable {
  // Section Overflow
  static defaultSectionOverflowDuration: string = '20';

  static empty(): MenuMetadata {
    const empty = new MenuMetadata();
    Object.keys(empty)?.forEach(key => (empty[key] = undefined));
    return empty;
  }

  public backgroundOpacity: string = '';
  public cardCount: string;
  public cardType: CardType;
  public printCardSize: CardSize;
  public price: string;
  public cardStartAt: string = DefaultCardStartAt;
  public carouselDuration: string;
  public hideCardNumber: string;
  public sectionOverflowDuration: string = MenuMetadata.defaultSectionOverflowDuration;

  onDeserialize() {
    this.backgroundOpacity = this.backgroundOpacity || '1';
    this.cardStartAt = this.cardStartAt || DefaultCardStartAt;
    this.sectionOverflowDuration = this.sectionOverflowDuration || MenuMetadata.defaultSectionOverflowDuration;
  }
}
